import { render, staticRenderFns } from "./Ofertas.vue?vue&type=template&id=94a96a14&scoped=true"
import script from "./Ofertas.vue?vue&type=script&lang=js"
export * from "./Ofertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a96a14",
  null
  
)

export default component.exports